import { render, staticRenderFns } from "./PromotionBulkEditor.vue?vue&type=template&id=e6e5d266&scoped=true"
import script from "./PromotionBulkEditor.vue?vue&type=script&lang=js"
export * from "./PromotionBulkEditor.vue?vue&type=script&lang=js"
import style0 from "./PromotionBulkEditor.vue?vue&type=style&index=0&id=e6e5d266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5d266",
  null
  
)

export default component.exports